import { TwoFactorSubmitArgs } from 'types/api/arguments/two-factor-submit-args'
import { TwoFactorResendResp } from 'types/api/response/two-factor-resend-resp'

import { api } from './api'

export const resendTwoFactorCode = ({ userId, id, code, fingerprint }: TwoFactorSubmitArgs) =>
  api.post<TwoFactorResendResp>(`/users/${userId}/user_2fa/${id}/resend`, {
    code,
    fingerprint,
  })
